/**
 * Created by RoryHe on 2020/12/2.
 */
import Vue from 'vue'
// import '@/assets/css/theme/index.css'
// import '@/assets/css/formGenerate.css'
import '@com.thunisoft.9law/form-generate/lib/formGenerate.css'
import '@/assets/css/element-variables.scss'
import {
  Input,
  InputNumber,
  Collapse,
  CollapseItem,
  Carousel,
  CarouselItem,
  Table,
  TableColumn,
  Select,
  Option,
  OptionGroup,
  MessageBox,
  Message,
  Alert,
  Notification,
  Button,
  ButtonGroup,
  Radio,
  RadioGroup,
  RadioButton,
  DatePicker,
  Row,
  Col,
  Tabs,
  TabPane,
  Cascader,
  Tooltip,
  Tree,
  Progress,
  Checkbox,
  Pagination,
  Dialog,
  Form,
  FormItem,
  Upload,
  Loading,
  Empty,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  Card,
  Backtop,
  Icon,
  Timeline,
  TimelineItem,
  CheckboxGroup,
  Popover,
  Divider,
  Steps,
  Step,
  Tag,
  Badge,
  Breadcrumb,
  BreadcrumbItem,
  TimePicker,
  ColorPicker,
  Descriptions,
  DescriptionsItem,
  Switch,
  Scrollbar,
  Drawer,
  InfiniteScroll,
  Menu,
  MenuItem,
  Submenu,
  Main,
  Container,
  Header,
  Aside,
  Popconfirm,
  CustomTable,
  BrowserTip,
  FilePreview,
  Query
} from '@com.thunisoft.9law/element-ui'

Vue.use(Tabs)
Vue.use(TabPane)
Vue.use(Row)
Vue.use(Col)
Vue.use(DatePicker)
Vue.use(Input)
Vue.use(InputNumber)
Vue.use(Radio)
Vue.use(RadioGroup)
Vue.use(RadioButton)
Vue.use(Button)
Vue.use(ButtonGroup)
Vue.use(Collapse)
Vue.use(CollapseItem)
Vue.use(Carousel)
Vue.use(CarouselItem)
Vue.use(Table)
Vue.use(TableColumn)
Vue.use(Select)
Vue.use(OptionGroup)
Vue.use(Option)
Vue.use(Cascader)
Vue.use(Alert)
Vue.use(Tooltip)
Vue.use(Tree)
Vue.use(Progress)
Vue.use(Checkbox)
Vue.use(CheckboxGroup)
Vue.use(Pagination)
Vue.use(Dialog)
Vue.use(Form)
Vue.use(FormItem)
Vue.use(Upload)
Vue.use(Loading)
Vue.use(Empty)
Vue.use(Dropdown)
Vue.use(DropdownMenu)
Vue.use(DropdownItem)
Vue.use(Card)
Vue.use(Backtop)
Vue.use(Icon)
Vue.use(Timeline)
Vue.use(TimelineItem)
Vue.use(Popover)
Vue.use(Divider)
Vue.use(Steps)
Vue.use(Step)
Vue.use(Tag)
Vue.use(Badge)
Vue.use(Breadcrumb)
Vue.use(BreadcrumbItem)
Vue.use(TimePicker)
Vue.use(ColorPicker)
Vue.use(Descriptions)
Vue.use(DescriptionsItem)
Vue.use(Switch)
Vue.use(Scrollbar)
Vue.use(Drawer)
Vue.use(InfiniteScroll)
Vue.use(Menu)
Vue.use(MenuItem)
Vue.use(Submenu)
Vue.use(Main)
Vue.use(Container)
Vue.use(Header)
Vue.use(Aside)
Vue.use(Popconfirm)
Vue.use(CustomTable)
Vue.use(BrowserTip)
Vue.use(FilePreview)
Vue.use(Query)

Vue.prototype.$msgbox = MessageBox;
Vue.prototype.$alert = MessageBox.alert;
Vue.prototype.$confirm = MessageBox.confirm;
Vue.prototype.$prompt = MessageBox.prompt;
Vue.prototype.$notify = Notification;
Vue.prototype.$message = Message;
